import type {Ref} from "vue";

/** Coerce currentDate (number | string | Date) to epoch seconds */
export function toEpochSeconds(v: unknown): number {
    if (typeof v === "number") return Math.floor(v);
    if (v instanceof Date) return Math.floor(v.getTime() / 1000);
    if (typeof v === "string") {
        const n = Number(v);
        if (!Number.isNaN(n)) return Math.floor(n);
        const d = new Date(v);
        if (!Number.isNaN(d.getTime())) return Math.floor(d.getTime() / 1000);
    }
    return 0;
}


/* see docs/EXTRACTED_COMMENTS.md#c170 */
export function locateStepByEpoch(epochSec: number, totalLength:  Ref<number, number>, orderedSteps: Readonly<Ref<any[]>>) {
    const total = totalLength.value || 0;
    if (!orderedSteps.value.length || total <= 0) return { step: undefined, index: 0, remaining: 0 };

    const offset = (epochSec / 1000) % total;
    let acc = 0;
    for (let i = 0; i < orderedSteps.value.length; i++) {
        const s = orderedSteps.value[i];
        const nextAcc = acc + s.length;
        if (offset < nextAcc) {
            const remaining = nextAcc - offset; // seconds left in this step
            return { step: s, index: i, remaining };
        }
        acc = nextAcc;
    }
   return null;
}